import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IncorporadorasModalComponent } from './incorporadoras-modal.component';
import { FormsModule } from '@angular/forms';
import { NbCardModule } from '@nebular/theme';
import { NgSelectModule } from '@ng-select/ng-select';//https://github.com/ng-select/ng-select

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NbCardModule,
    NgSelectModule,
  ],
  declarations: [
    IncorporadorasModalComponent
  ]
})
export class IncorporadorasModalModule { }



// WEBPACK FOOTER //
// ./src/app/pages/incorporadoras/modal/incorporadoras-modal.module.ts